import { useEffect, useState } from "react";
import { mediaUrl } from "@/lib/api";

/** Calm cross-fading hero slideshow. Falls back to a gray placeholder. */
export default function HeroSlideshow({ imageIds = [], interval = 6000 }) {
  const ids = imageIds.filter(Boolean);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (ids.length <= 1) return;
    const t = setInterval(() => setIndex((i) => (i + 1) % ids.length), interval);
    return () => clearInterval(t);
  }, [ids.length, interval]);

  if (ids.length === 0) {
    return <div className="ph bg-[#F3E7D2] aspect-[4/5] w-full" role="img" aria-label="Kunstwerk Platzhalter" />;
  }

  return (
    <div className="relative w-full aspect-[4/5] overflow-hidden bg-[#F3E7D2]" data-testid="hero-slideshow">
      {ids.map((id, i) => (
        <img
          key={id}
          src={mediaUrl(id)}
          alt="Ausgewähltes Kunstwerk"
          loading={i === 0 ? "eager" : "lazy"}
          className="absolute inset-0 w-full h-full object-cover transition-opacity duration-[1500ms] ease-in-out"
          style={{ opacity: i === index ? 1 : 0 }}
          aria-hidden={i === index ? undefined : true}
        />
      ))}
      {ids.length > 1 && (
        <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2 z-10">
          {ids.map((_, i) => (
            <button
              key={i}
              onClick={() => setIndex(i)}
              aria-label={`Bild ${i + 1} anzeigen`}
              data-testid={`hero-dot-${i}`}
              className={`h-1.5 rounded-full transition-all duration-300 ${
                i === index ? "w-6 bg-white/90" : "w-1.5 bg-white/50 hover:bg-white/70"
              }`}
            />
          ))}
        </div>
      )}
    </div>
  );
}
